<template>
  <div class="standard-lead" :style="{transform: 'scale('+scal+')' }">
    
    <div class="new-title">{{ $theme ?  '以自主知识产权参与行业标准制定，助力中国的国际竞争' : "Participate in the formulation of industry standards with independent intellectual property rights to help China's international competition"}}</div>
    <div class="list">
      <div v-for="item in list" :key="item.id" :class="`item ${active === item.id?'active':''}`" @mouseenter="onMouseEnter(item.id)">
        <div class="name">{{ $theme ? item.name : item.nameEng}}</div>
        <div class="title">{{ $theme ? item.title : item.content}}</div>
        <div class="title">{{$theme ? item.subtitle : ''}}</div>
        <div class="content">{{$theme ? item.content : ''}}</div>
        <div class="color-block"></div>
        <div class="standard">{{item.standard}}</div>
        <img v-if="active !== item.id" :src="require(`../../../../assets/img/brand-honor/standard-lead-item-${item.id}.png`)" />
      </div>
    </div>
  </div>
</template>

<script>
import modTitle from '../../../../components/mod-title/Index.vue'

export default {
  name: 'PropertyRights',
  components: {
    modTitle
  },
  data() {
    return {
      active: 1,
      list: [
        {
          id: 1,
          name: '中华人民共和国交通运输行业标准',
          nameEng: "Transportation Industry Standards of the People's Republic of China",
          title: '营运车辆全景环视系统技术',
          subtitle: '要求和试验方法',
          content: 'Commercial vehicle around view monitor system technical requirements and test procedurs',
          standard: 'JT/T 2020-06'
        },
        {
          id: 2,
          name: '河北省地方标准',
          nameEng: "Hebei Provincial Standard",
          title: '污染物在线自动监控（监测）',
          subtitle: '物联网关侧技术算法',
          content: 'The technology and algorithm of Internet of Things gateway for online automatic monitoring systems of pollutant',
          standard: 'DB13'
        },
        {
          id: 3,
          name: '河北省地方标准',
          nameEng: "Hebei Provincial Standard",
          title: '污染物在线自动监控（监测）',
          subtitle: '终端侧技术算法',
          content: 'The technology and algorithm of Internet of Things terminal for online automatic monitoring systems of pollutant',
          standard: 'DB13'
        }
      ],
      scal: 1,
    }
  },
  methods: {
    onMouseEnter(id) {
      this.active = id
    }
  },
  mounted() {
    var element = document.body.clientWidth;
    // this.scal = element/1920
    
  }
}
</script>
<style lang="scss" scoped>
@import './Index.scss';
</style>
